import { c as _c } from "react/compiler-runtime";
import { Image } from '@/components/client';
import { getStaticCdnUrl } from '@/utils';
import { checkTodayInRange } from '@/utils/checkTodayInRange';
const NOTICE_IMAGE_URL = getStaticCdnUrl('donation/delivery-notice-august.png');

/** 원본 자산 픽셀 크기 — 슬롯 비율이 여기서 파생되므로 자산 교체 시 함께 갱신한다 */
const NOTICE_IMAGE_WIDTH = 3_240;
const NOTICE_IMAGE_HEIGHT = 4_644;
const NOTICE_START_AT = '2026-08-13T00:00:00+09:00';
const NOTICE_END_AT = '2026-08-17T23:59:59+09:00';
export const DeliveryNoticeImage = () => {
  const $ = _c(1);
  if (!checkTodayInRange(NOTICE_START_AT, NOTICE_END_AT)) {
    return null;
  }
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Image src={NOTICE_IMAGE_URL} alt={"8\uC6D4 \uBC30\uC1A1\xB7\uD734\uBB34 \uC548\uB0B4. 8\uC6D4 14\uC77C\uBD80\uD130 17\uC77C\uAE4C\uC9C0 \uD0DD\uBC30\uC0AC\uAC00 \uD734\uBB34\uC774\uBA70, \uD734\uBB34 \uC804\uC77C\uC778 8\uC6D4 13\uC77C \uC8FC\uBB38 \uAC74\uC740 8\uC6D4 18\uC77C\uBD80\uD130 \uC21C\uCC28\uC801\uC73C\uB85C \uCD9C\uACE0\uB420 \uC218 \uC788\uC2B5\uB2C8\uB2E4."} width={NOTICE_IMAGE_WIDTH} height={NOTICE_IMAGE_HEIGHT} className="h-auto w-full" sizes="(max-width: 768px) 100vw, 850px" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};